import { SettingsSecondaryMenuPage } from "../types.js";

export const isSettingsSecondaryMenuPage = (page: unknown): page is SettingsSecondaryMenuPage =>
    typeof page === "string" && Object.values(SettingsSecondaryMenuPage).includes(page as SettingsSecondaryMenuPage);
